module.exports = __webpack_public_path__ + "static/selc.d31ab28e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/selc.png
// module id = 892
// module chunks = 169928946856436